export const FOOTER_SELECT_CURRENCY_TEST_ID = "footer-select-currency";
